(() => {
  'use strict';
  if (window.ITPPresentation28) return;
  let previous = null;
  const dialog = () => document.querySelector('[data-presentation28-dialog]');
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a.itp28-mark');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    const modal = dialog();
    if (!modal || typeof modal.showModal !== 'function') return;
    event.preventDefault();
    event.stopPropagation();
    if (modal.open) return;
    previous = link;
    try { modal.showModal(); modal.querySelector('h2')?.focus({preventScroll:true}); }
    catch { link.focus({preventScroll:true}); }
  }, true);
  document.addEventListener('click', event => {
    const modal = dialog();
    if (!modal?.open) return;
    if (event.target.closest?.('[data-presentation28-close]')) modal.close();
    else if (event.target === modal) {
      const rect = modal.getBoundingClientRect();
      if (event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom) modal.close();
    }
  });
  document.addEventListener('close', event => {
    if (!event.target.matches?.('[data-presentation28-dialog]')) return;
    const restore=previous; previous=null;
    if (restore?.isConnected) restore.focus({preventScroll:true});
  }, true);
  window.ITPPresentation28 = Object.freeze({version:28});
})();
